<input type="checkbox" [ngClass]="{'indeterminate': showLine, 'disabled': showCross}" [disabled]="disabled" id="{{id}}" (click)="check($event)">
<label for="{{id}}">{{ label | translate }}</label>